import { IMediaLibraryOnSubmitCategory, ITransformControlsMode } from '@/../typings';
import { CHROMA_KEY_DEFAULT_COLOR, CHROMA_KEY_DEFAULT_SIMILARITY, CHROMA_KEY_DEFAULT_SMOOTHNESS, CHROMA_KEY_DEFAULT_SPILL, DEFAULT_SCREEN_RELATIVE_DEVICE, INITIAL_ZOOM_LEVEL, SCREEN_RELATIVE_DEVICES, } from '@/utils';
import { IComponentType } from '@r3f-component-data-structure';
import { MathUtils } from 'three';
import { IUserActionTypes } from '../actions/action-types';
const setMultipleEntitySelectBoundary = (state, action) => {
    return {
        ...state,
        multipleEntitySelectBoundary: JSON.parse(JSON.stringify(action.payload)),
    };
};
const setUserId = (state, action) => {
    return {
        ...state,
        userId: action.payload.userId,
    };
};
const setEmitterAreaScales = (state, action) => {
    let emitterAreaScalesDict = action.payload;
    if (action.payload === null) {
        emitterAreaScalesDict = Object.keys(state.emitterAreaScalesById).reduce((acc, id) => {
            acc[id] = null;
            return acc;
        }, {});
    }
    return {
        ...state,
        emitterAreaScalesById: {
            ...state.emitterAreaScalesById,
            ...emitterAreaScalesDict,
        },
    };
};
const setEmitterIsStatic = (state, action) => {
    return {
        ...state,
        emitterIsStaticById: {
            ...state.emitterIsStaticById,
            ...action.payload,
        },
    };
};
const setPreviewCodeSrc = (state, action) => {
    return {
        ...state,
        previewCodeSrc: action.payload,
    };
};
const onSetPreviewUrl = (state, action) => {
    return {
        ...state,
        previewUrl: action.payload,
    };
};
const setDragControlsUpdateTrigger = (state, action) => {
    return {
        ...state,
        forceUpdateDragControlsTrigger: action.payload,
    };
};
const setTemporaryDragRotation = (state, action) => {
    return {
        ...state,
        temporaryDragRotation: action.payload,
    };
};
const setVideoRenditionProgress = (state, action) => {
    const { id, progress } = action.payload;
    const videoProgressById = { ...(state.videoProgressById ?? {}) };
    if (progress === null)
        delete videoProgressById[id];
    else
        videoProgressById[id] = progress;
    return {
        ...state,
        videoProgressById,
    };
};
const setPublishPopup = (state, action) => {
    return {
        ...state,
        showPublishPopup: action.payload,
    };
};
const setPublishTrigger = (state, action) => {
    return {
        ...state,
        publishTrigger: action.payload,
    };
};
const setActivePreviewTrackingImageIndex = (state, action) => {
    return {
        ...state,
        activePreviewTrackingImageIndex: action.payload,
    };
};
const setUpdateTrigger = (state, action) => {
    return {
        ...state,
        updateTrigger: action.payload,
    };
};
const setWhatsNewTrigger = (state) => {
    return {
        ...state,
        whatsNewTrigger: state.whatsNewTrigger + 1,
    };
};
const setSpinnerCoordinates = (state, action) => {
    const existingData = { ...state.spinnerData };
    const { id, ...rest } = action.payload;
    if (rest.coords === null)
        delete existingData[id];
    else
        existingData[id] = rest;
    return {
        ...state,
        spinnerData: existingData,
    };
};
const setSelectedTemplateProject = (state, action) => {
    return {
        ...state,
        selectedTemplateProject: { ...action.payload },
    };
};
const setPositions = (state, action) => {
    let positionDict = action.payload;
    if (action.payload === null) {
        positionDict = Object.keys(state.positionById).reduce((acc, id) => {
            acc[id] = null;
            return acc;
        }, {});
    }
    return {
        ...state,
        positionById: {
            ...state.positionById,
            ...positionDict,
        },
    };
};
const setCurvatures = (state, action) => {
    let curvatureDict = action.payload;
    if (action.payload === null) {
        curvatureDict = Object.keys(state.curvatureById).reduce((acc, id) => {
            acc[id] = null;
            return acc;
        }, {});
    }
    return {
        ...state,
        curvatureById: {
            ...state.curvatureById,
            ...curvatureDict,
        },
    };
};
const setScales = (state, action) => {
    let scaleDict = action.payload;
    if (action.payload === null) {
        scaleDict = Object.keys(state.scaleById).reduce((acc, id) => {
            acc[id] = null;
            return acc;
        }, {});
    }
    return {
        ...state,
        scaleById: {
            ...state.scaleById,
            ...scaleDict,
        },
    };
};
const setRotations = (state, action) => {
    let rotationDict = action.payload;
    if (action.payload === null) {
        rotationDict = Object.keys(state.rotationById).reduce((acc, id) => {
            acc[id] = null;
            return acc;
        }, {});
    }
    return {
        ...state,
        rotationById: {
            ...state.rotationById,
            ...rotationDict,
        },
    };
};
const setFillRgba = (state, action) => {
    let fillRgbaDict = action.payload;
    if (action.payload === null) {
        fillRgbaDict = Object.keys(state.fillRgbaById).reduce((acc, id) => {
            acc[id] = null;
            return acc;
        }, {});
    }
    return {
        ...state,
        fillRgbaById: {
            ...state.fillRgbaById,
            ...fillRgbaDict,
        },
    };
};
const setFontRgba = (state, action) => {
    let fontRgbaDict = action.payload;
    if (action.payload === null) {
        fontRgbaDict = Object.keys(state.fontRgbaById).reduce((acc, id) => {
            acc[id] = null;
            return acc;
        }, {});
    }
    return {
        ...state,
        fontRgbaById: {
            ...state.fontRgbaById,
            ...fontRgbaDict,
        },
    };
};
const setBorderRgba = (state, action) => {
    let borderRgbaDict = action.payload;
    if (action.payload === null) {
        borderRgbaDict = Object.keys(state.borderRgbaById).reduce((acc, id) => {
            acc[id] = null;
            return acc;
        }, {});
    }
    return {
        ...state,
        borderRgbaById: {
            ...state.borderRgbaById,
            ...borderRgbaDict,
        },
    };
};
const setActiveFaceLandmark = (state, action) => {
    return {
        ...state,
        activeFaceLandmark: action.payload,
    };
};
const addToast = (state, action) => {
    const singleton = action.payload?.singleton || true;
    if (singleton) {
        const showingToastMessageAlready = state.toasts.filter((toast) => toast.message === action.payload?.message).length !== 0;
        if (showingToastMessageAlready)
            return state;
    }
    const id = action.payload?.id || MathUtils.generateUUID();
    const toast = { ...action.payload, id };
    const deepCopiedToasts = JSON.parse(JSON.stringify(state.toasts));
    const newToasts = [...deepCopiedToasts, toast];
    return {
        ...state,
        toasts: newToasts,
    };
};
const removeToast = (state, action) => {
    const id = action.payload;
    const newToasts = state.toasts.filter((toast) => toast.id !== id);
    return {
        ...state,
        toasts: newToasts,
    };
};
const setTrackingImageIsUploading = (state, action) => {
    return {
        ...state,
        trkImgIsUploading: action.payload,
    };
};
const setTrackingImageData = (state, action) => {
    return {
        ...state,
        trackImgData: {
            ...state.trackImgData,
            ...action.payload,
        },
    };
};
const removeTrackingImageData = (state) => {
    const trackImgData = null;
    return {
        ...state,
        trackImgData,
    };
};
const setOpenInspectorMenuEntityShelf = (state, action) => {
    const shelf = action.payload;
    const inspectorMenuShelves = shelf ? [shelf] : []; // Empty array because when set to null the 'Content' and 'Transforms' are open for first load
    return {
        ...state,
        openInspectorMenuEntityShelves: inspectorMenuShelves,
    };
};
const setOpenEntityMenuDrawer = (state, action) => {
    const { openEntityMenuDrawer } = action.payload;
    return {
        ...state,
        openEntityMenuDrawer,
    };
};
const setOpenEntityMenuCategoryDrawer = (state, action) => {
    const { openEntityCategoryDrawerDict } = action.payload;
    return {
        ...state,
        openEntityCategoryDrawerDict: { ...state.openEntityCategoryDrawerDict, ...openEntityCategoryDrawerDict },
    };
};
const setCanvasIsLoaded = (state, action) => {
    return {
        ...state,
        canvasLoaded: action.payload,
    };
};
// const setLoadedAudio = (state: IUserState, action: ISetLoadedAudioAction): IUserState => {
// 	return {
// 		...state,
// 		loadedAudio: action.payload,
// 	};
// };
const setLoadedBackground360Content = (state, action) => {
    return {
        ...state,
        loadedBackgroundContent: action.payload,
    };
};
const removeLoadedMedia = (state, action) => {
    switch (action.payload.type) {
        case IComponentType.Model3d: {
            const loaded3dModels = [];
            return { ...state, loaded3dModels };
        }
        case IComponentType.Image: {
            const loadedImages = [];
            return { ...state, loadedImages };
        }
        case IComponentType.Video: {
            const loadedVideos = [];
            return { ...state, loadedVideos };
        }
        default:
            return state;
    }
};
// const addToLoadedMedia = (state: IUserState, action: IOnAddToLoadedMediaAction): IUserState => {
// 	let media = [] as ILoadedComponentUnion[];
// 	switch (action.payload.entity.type) {
// 		case IComponentType.Model3d:
// 			media = state.loaded3dModels ? JSON.parse(JSON.stringify(state.loaded3dModels)) : [];
// 			break;
// 		case IComponentType.Image:
// 			media = state.loadedImages ? JSON.parse(JSON.stringify(state.loadedImages)) : [];
// 			break;
// 		case IComponentType.Video:
// 			media = state.loadedVideos ? JSON.parse(JSON.stringify(state.loadedVideos)) : [];
// 			break;
// 	}
// 	switch (action.payload.position) {
// 		case IAddMediaPositionTypes.start:
// 			media = [...[action.payload.entity], ...media];
// 			break;
// 		case IAddMediaPositionTypes.end:
// 		case IAddMediaPositionTypes.date:
// 			media = [...media, ...[action.payload.entity]];
// 			break;
// 		default:
// 			media = [action.payload.entity];
// 			break;
// 	}
// 	switch (action.payload.entity.type) {
// 		case IComponentType.Image:
// 			return { ...state, loadedImages: media as ILoadedImage[] };
// 		case IComponentType.Model3d:
// 			return { ...state, loaded3dModels: media as ILoadedModel3d[] };
// 		case IComponentType.Video:
// 			return { ...state, loadedVideos: media as ILoadedVideo[] };
// 		default:
// 			return state;
// 	}
// };
// const addToLoadedAudio = (state: IUserState, action: IOnAddToLoadedAudioAction): IUserState => {
// 	let media = state.loadedAudio ? JSON.parse(JSON.stringify(state.loadedAudio)) : ([] as IAudio[]);
// 	switch (action.payload.position) {
// 		case IAddMediaPositionTypes.start:
// 			media = [...[action.payload.entity], ...media];
// 			break;
// 		case IAddMediaPositionTypes.end:
// 		case IAddMediaPositionTypes.date:
// 			media = [...media, ...[action.payload.entity]];
// 			break;
// 		default:
// 			media = [action.payload.entity];
// 			break;
// 	}
// 	return { ...state, loadedAudio: media as any };
// };
const removeUpload = (state, action) => {
    const id = action.payload;
    const currentUploads = JSON.parse(JSON.stringify(state.currentUploads));
    let { numberProcessedUploads } = state;
    delete currentUploads[id];
    if (!Object.keys(currentUploads).length) {
        numberProcessedUploads = 0;
    }
    else {
        numberProcessedUploads--;
    }
    return {
        ...state,
        currentUploads,
        numberProcessedUploads,
    };
};
const setCurrentUploads = (state, action) => {
    const { id, progress } = action.payload;
    const currentUploads = JSON.parse(JSON.stringify(state.currentUploads));
    let { numberProcessedUploads } = state;
    // remove from uploads if payload null, else add progressInfo
    if (!progress) {
        delete currentUploads[id];
        if (!Object.keys(currentUploads).length)
            numberProcessedUploads = 0;
    }
    else {
        if (!currentUploads[id])
            numberProcessedUploads += 1;
        currentUploads[id] = { ...currentUploads[id], ...progress };
    }
    return {
        ...state,
        currentUploads,
        numberProcessedUploads,
    };
};
const setEntityMenuDragActive = (state, action) => {
    return {
        ...state,
        entityMenuDragActive: action.payload,
    };
};
// const setAudioStatus = (state: IUserState, action: IOnSetAudioStatusAction): IUserState => {
// 	const loadedAudio = JSON.parse(JSON.stringify(state.loadedAudio)) as IAudio[];
// 	loadedAudio[loadedAudio.findIndex((a) => a.id === action.payload.id)].status = action.payload.status ?? undefined;
// 	return {
// 		...state,
// 		loadedAudio,
// 	};
// };
const updateUsers = (state, action) => {
    const { users: syncUsers } = action.payload;
    const users = {};
    for (let index = 0; index < syncUsers.length; index++) {
        const syncUser = syncUsers[index];
        users[syncUser.id] = {
            ...syncUser,
        };
    }
    return {
        ...state,
        loggedInUsers: users,
    };
};
const setProjectInfo = (state, action) => {
    return { ...state, project: action.payload.project };
};
const setEntityDragInfo = (state, action) => {
    return { ...state, dragState: action.payload };
};
const setHotKey = (state, action) => {
    const { hotKey } = action.payload;
    return {
        ...state,
        hotKeys: [...state.hotKeys, hotKey],
    };
};
const removeHotKey = (state, action) => {
    const { hotKey } = action.payload;
    return {
        ...state,
        hotKeys: state.hotKeys.filter((key) => key !== hotKey),
    };
};
const setActiveScene = (state, action) => {
    const { activeSceneId } = action.payload;
    return {
        ...state,
        activeSceneId,
    };
};
const setSortedSceneSnapshots = (state, action) => {
    const sceneSnapshots = action.payload;
    return {
        ...state,
        sceneSnapshots,
    };
};
const setCurrentSceneIndex = (state, action) => {
    const currentSceneIndex = action.payload;
    return {
        ...state,
        currentSceneIndex,
    };
};
const scrollSceneMenu = (state, action) => {
    const scrollSceneMenu = action.payload;
    return {
        ...state,
        scrollSceneMenu,
    };
};
const setSceneMenuLarge = (state, action) => {
    return {
        ...state,
        sceneMenuIsLarge: action.payload,
    };
};
const setPositioningActive = (state, action) => {
    return {
        ...state,
        positioningIsActive: action.payload,
    };
};
const setScaleHotSpotEnabled = (state, action) => {
    return {
        ...state,
        scaleHotspotIsEnabled: action.payload,
    };
};
const setRotationActive = (state, action) => {
    return {
        ...state,
        rotationIsActive: action.payload,
    };
};
const setBackgroundHotSpotEnabled = (state, action) => {
    return {
        ...state,
        backgroundHotspotIsEnabled: action.payload,
    };
};
const setPointerOffset = (state, action) => {
    return {
        ...state,
        pointerOffset: action.payload,
    };
};
const setMarkerIndexPressed = (state, action) => {
    return {
        ...state,
        markerIndexPressed: action.payload,
    };
};
const setSceneEntityListVisible = (state, action) => {
    return {
        ...state,
        sceneEntityListIsVisible: action.payload.isVisible,
        ...(action.payload.position && {
            sceneEntityListPosition: action.payload.position,
        }),
    };
};
const disableUndo = (state, action) => {
    return {
        ...state,
        undoDisabled: action.payload,
    };
};
const disableRedo = (state, action) => {
    return {
        ...state,
        redoDisabled: action.payload,
    };
};
const isLoadingMedia = (state, action) => {
    return {
        ...state,
        loadingMedia: action.payload,
    };
};
const addEntityIdsToSelection = (state, action) => {
    const selEntities = state.selectedEntityIds || [];
    const noDuplicates = new Set([...selEntities, ...action.payload]);
    return {
        ...state,
        selectedEntityIds: Array.from(noDuplicates),
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const removeLocalUserSelection = (state, _action) => {
    return {
        ...state,
        selectedEntityIds: [],
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const removeSelection = (state, action) => {
    const entityIds = action.payload;
    let { selectedEntityIds } = state;
    if (!entityIds) {
        selectedEntityIds = [];
    }
    else {
        selectedEntityIds = selectedEntityIds?.filter((entity) => entityIds.indexOf(entity) === -1);
    }
    return {
        ...state,
        selectedEntityIds,
    };
};
const changeZoomLevel = (state, action) => {
    return {
        ...state,
        zoomLevel: action.payload,
    };
};
const setSocketConnected = (state, action) => {
    return {
        ...state,
        socketConnected: action.payload,
    };
};
const setProjectLoadingProgress = (state, action) => {
    return {
        ...state,
        projectLoadingProgress: action.payload,
    };
};
const setProjectLoadingFailure = (state, action) => {
    return {
        ...state,
        projectLoadingFailure: action.payload,
    };
};
const setSelection2DPosition = (state, action) => {
    if (!state.selectedObject2DPosition && !action.payload)
        return state;
    if (state.selectedObject2DPosition && action.payload && state.selectedObject2DPosition[0] === action.payload[0] && state.selectedObject2DPosition[1] === action.payload[1]) {
        // No change
        return state;
    }
    return {
        ...state,
        selectedObject2DPosition: action.payload,
    };
};
const setSceneCarouselScrollLeft = (state, action) => {
    return {
        ...state,
        sceneCarouselScrollLeft: action.payload,
    };
};
const focusSceneNameInput = (state, action) => {
    return {
        ...state,
        sceneNameInputIsFocused: action.payload,
    };
};
const setSelection2DTopLeftPosition = (state, action) => {
    if (!state.selectionTopLeft2DPosition && !action.payload)
        return state;
    if (state.selectionTopLeft2DPosition && action.payload && state.selectionTopLeft2DPosition[0] === action.payload[0] && state.selectionTopLeft2DPosition[1] === action.payload[1]) {
        // No change
        return state;
    }
    return {
        ...state,
        selectionTopLeft2DPosition: action.payload,
    };
};
const setSelection2DTopRightPosition = (state, action) => {
    if (!state.selectionTopRight2DPosition && !action.payload)
        return state;
    if (state.selectionTopRight2DPosition && action.payload && state.selectionTopRight2DPosition[0] === action.payload[0] && state.selectionTopRight2DPosition[1] === action.payload[1]) {
        // No change
        return state;
    }
    return {
        ...state,
        selectionTopRight2DPosition: action.payload,
    };
};
const setSelection2DBottomLeftPosition = (state, action) => {
    if (!state.selectionBottomLeft2DPosition && !action.payload)
        return state;
    if (state.selectionBottomLeft2DPosition && action.payload && state.selectionBottomLeft2DPosition[0] === action.payload[0] && state.selectionBottomLeft2DPosition[1] === action.payload[1]) {
        // No change
        return state;
    }
    return {
        ...state,
        selectionBottomLeft2DPosition: action.payload,
    };
};
const setSelection2DBottomRightPosition = (state, action) => {
    if (!state.selectionBottomRight2DPosition && !action.payload)
        return state;
    if (state.selectionBottomRight2DPosition && action.payload && state.selectionBottomRight2DPosition[0] === action.payload[0] && state.selectionBottomRight2DPosition[1] === action.payload[1]) {
        // No change
        return state;
    }
    return {
        ...state,
        selectionBottomRight2DPosition: action.payload,
    };
};
///////
const setRotationMarker2DPosition = (state, action) => {
    if (!state.rotationMarker2DPosition && !action.payload)
        return state;
    if (state.rotationMarker2DPosition && action.payload && state.rotationMarker2DPosition[0] === action.payload[0] && state.rotationMarker2DPosition[1] === action.payload[1]) {
        // No change
        return state;
    }
    return {
        ...state,
        rotationMarker2DPosition: action.payload,
    };
};
const setEntityMenuHotspotDragPosition = (state, action) => {
    return {
        ...state,
        entityDragHotspotPosition: action.payload,
    };
};
const setSelectedEntityIds = (state, action) => {
    const noDuplicates = new Set(action.payload);
    return {
        ...state,
        selectedEntityIds: Array.from(noDuplicates),
    };
};
const setPureReactInCanvasHovered = (state, action) => {
    return {
        ...state,
        pureReactInCanvasHovered: action.payload,
    };
};
const copySelectedEntities = (state, action) => {
    const copiedEntityIds = action.payload;
    if (!copiedEntityIds)
        return state;
    return {
        ...state,
        copiedEntityIds,
    };
};
const setGroupInversion = (state, action) => {
    const { xInverted: groupIsXInverted, yInverted: groupIsYInverted } = action.payload;
    return {
        ...state,
        ...(typeof groupIsXInverted !== 'undefined' && { groupIsXInverted }),
        ...(typeof groupIsYInverted !== 'undefined' && { groupIsYInverted }),
    };
};
const setEditSceneTitle = (state, action) => {
    const editSceneTitle = action.payload;
    return {
        ...state,
        editSceneTitle,
    };
};
const set3dMode = (state, action) => {
    return {
        ...state,
        is3dMode: action.payload,
    };
};
const setIsScreenRelativeMode = (state, action) => {
    return {
        ...state,
        isScreenRelativeMode: action.payload,
    };
};
const setOpenModal = (state, action) => {
    const modalById = state.modalById;
    // Close all others
    for (const modalId in modalById) {
        modalById[modalId] = false;
    }
    // Open this one
    modalById[action.payload] = true;
    return {
        ...state,
        modalById,
    };
};
const setCloseModal = (state, _action) => {
    const modalById = state.modalById;
    // Close all modals
    for (const modalId in modalById) {
        modalById[modalId] = false;
    }
    return {
        ...state,
        modalById,
    };
};
const setFileVerifying = (state, action) => {
    const { isVerifying } = action.payload;
    return {
        ...state,
        fileVerifying: isVerifying,
    };
};
const setReplaceEntityMode = (state, action) => {
    const { replaceEntityMode } = action.payload;
    return {
        ...state,
        mediaLibraryDisplay: {
            fileTypes: state.mediaLibraryDisplay.fileTypes,
            onSubmitCategory: replaceEntityMode ? IMediaLibraryOnSubmitCategory.ReplaceEntity : IMediaLibraryOnSubmitCategory.AddToScene,
        },
    };
};
const setIsWebEmbedEditingMode = (state, action) => {
    const isWebEmbedEditingMode = action.payload;
    return {
        ...state,
        isWebEmbedEditingMode: isWebEmbedEditingMode,
    };
};
const setTransformControlsActive = (state, action) => {
    return {
        ...state,
        transformControlsActive: action.payload,
    };
};
const setTransformControlsMode = (state, action) => {
    return {
        ...state,
        transformControlsMode: action.payload,
    };
};
const setScreenRelativeDevice = (state, action) => {
    return {
        ...state,
        screenRelativeDevice: action.payload,
    };
};
const setScreenRelativeDevicePreviousCustomDimensions = (state, action) => {
    return {
        ...state,
        screenRelativeDevicePreviousCustomDimensions: action.payload,
    };
};
const setChromaKeyEditModalData = (state, action) => {
    const data = state.chromaKeyEditModalData;
    if (typeof data.chromaKey == 'undefined')
        data.chromaKey = {};
    if (typeof action.payload.chromaKey?.color !== 'undefined')
        data.chromaKey.color = action.payload.chromaKey.color;
    if (typeof action.payload.chromaKey?.smoothness !== 'undefined')
        data.chromaKey.smoothness = action.payload.chromaKey.smoothness;
    if (typeof action.payload.chromaKey?.similarity !== 'undefined')
        data.chromaKey.similarity = action.payload.chromaKey.similarity;
    if (typeof action.payload.chromaKey?.spill !== 'undefined')
        data.chromaKey.spill = action.payload.chromaKey.spill;
    if (typeof action.payload.filestoreId !== 'undefined')
        data.filestoreId = action.payload.filestoreId;
    return { ...state, chromaKeyEditModalData: data };
};
const setWebEmbedPreviewSettings = (state, action) => {
    // webEmbed settings are optional ( for projects without AR Web Embed trigger )
    // So need some default values in case an action is dispatched with partial data
    const initialValues = {
        height: 400,
        width: 600,
    };
    const webEmbed = {
        ...initialValues, // Initial required values
        ...state.webEmbed, // Overwritten by current state
        ...action.payload, // Overwritten by the current action
    };
    return {
        ...state,
        webEmbed,
    };
};
const setMediaLibraryDisplay = (state, action) => {
    const mediaLibraryDisplay = {
        ...state.mediaLibraryDisplay,
        ...action.payload,
    };
    return {
        ...state,
        mediaLibraryDisplay,
    };
};
const setSelectedAudio = (state, action) => {
    return { ...state, selectedAudio: action.payload };
};
const setOpenProjectMenuDrawer = (state, action) => {
    return {
        ...state,
        openInspectorMenuProjectShelves: action.payload,
    };
};
const setOpenSceneMenuDrawer = (state, action) => {
    return {
        ...state,
        openInspectorMenuSceneShelves: action.payload,
    };
};
const setTempAnimateModelAction = (state, action) => {
    return {
        ...state,
        tempAnimateModelAction: action.payload.action,
    };
};
const setVisibleCanvas = (state, action) => {
    const { canvasName, visible } = action.payload;
    const { visibleCanvases } = state;
    const visibleCanvasesCopy = { ...visibleCanvases };
    visibleCanvasesCopy[canvasName] = visible;
    return {
        ...state,
        visibleCanvases: visibleCanvasesCopy,
    };
};
const setShowFaceLandmarks = (state, action) => {
    return {
        ...state,
        showFaceLandmarks: action.payload,
    };
};
const setHoveredDropdownFaceLandmark = (state, action) => {
    return {
        ...state,
        hoveredDropdownFacelandmark: action.payload,
    };
};
const setProjectSizeLimit = (state, action) => {
    return {
        ...state,
        projectSizeLimit: action.payload,
    };
};
const setProjectSize = (state, action) => {
    return {
        ...state,
        projectSize: action.payload,
    };
};
const setTargetImageReferenceObjectPosition = (state, action) => {
    return {
        ...state,
        targetImageReferenceObjectPosition: action.payload,
    };
};
const setPopOutIdealTopPosition = (state, action) => {
    return {
        ...state,
        popOutIdealTopPosition: action.payload,
    };
};
// const setActiveAnimationPresetData = (state: IUserState, action: IOnSetActiveAnimationPresetData_Action): IUserState => {
// 	if (action.payload === null) {
// 		return {
// 			...state,
// 			activePresetAnimation: null
// 		}
// 	}
// 	if (state.activePresetAnimation === null) {
// 		return {
// 			...state,
// 			activePresetAnimation: action.payload as IActivePresetAnimationState
// 		}
// 	}
// 	return state;
// }
const setActiveAnimationPreset = (state, action) => {
    return {
        ...state,
        isPresetAnimationActive: action.payload,
    };
};
const setShowAppClipsModal = (state, action) => {
    return {
        ...state,
        showAppClipsModal: action.payload,
    };
};
const setPublishBtnStatus = (state, action) => {
    return { ...state, publishBtnStatus: action.payload };
};
const setPreviewBtnStatus = (state, action) => {
    return { ...state, previewBtnStatus: action.payload };
};
const setAppClipsConverted = (state, action) => {
    return {
        ...state,
        appClipsConverted: action.payload,
    };
};
const setIsUserAuthorized = (state, action) => {
    return {
        ...state,
        isUserAuthorized: action.payload,
    };
};
const setLaunchPageIconFilestoreId = (state, action) => {
    return {
        ...state,
        launchPageIconFilestoreId: action.payload
    };
};
const setActiveEditingActionData = (state, action) => {
    if (action.payload === null) {
        return {
            ...state,
            activeEditingActionData: null,
        };
    }
    else {
        return {
            ...state,
            activeEditingActionData: {
                ...state.activeEditingActionData,
                ...action.payload,
            },
        };
    }
};
function setProjectDuplicatingState(state, action) {
    return { ...state, isProjectDuplicating: action.payload };
}
const initialState = {
    activeEditingActionData: null,
    popOutIdealTopPosition: 150,
    isPresetAnimationActive: false,
    multipleEntitySelectBoundary: null,
    chromaKeyEditModalData: {
        chromaKey: { color: CHROMA_KEY_DEFAULT_COLOR, smoothness: CHROMA_KEY_DEFAULT_SMOOTHNESS, similarity: CHROMA_KEY_DEFAULT_SIMILARITY, spill: CHROMA_KEY_DEFAULT_SPILL },
    },
    targetImageReferenceObjectPosition: null,
    modalById: {},
    isWebEmbedEditingMode: false,
    is3dMode: false,
    isScreenRelativeMode: false,
    fileVerifying: false,
    screenRelativeDevice: SCREEN_RELATIVE_DEVICES[DEFAULT_SCREEN_RELATIVE_DEVICE],
    transformControlsMode: ITransformControlsMode.translate,
    transformControlsActive: false,
    zoomLevel: INITIAL_ZOOM_LEVEL,
    undoDisabled: true,
    redoDisabled: true,
    activeSceneId: null,
    projectLoadingProgress: 0,
    projectLoadingFailure: false,
    positioningIsActive: false,
    backgroundHotspotIsEnabled: false,
    rotationIsActive: false,
    scaleHotspotIsEnabled: false,
    markerIndexPressed: null,
    hotKeys: [],
    pointerOffset: [0, 0, 0],
    selectedEntityIds: [],
    selectedObject2DPosition: null,
    selectionBottomLeft2DPosition: null,
    selectionBottomRight2DPosition: null,
    selectionTopLeft2DPosition: null,
    selectionTopRight2DPosition: null,
    rotationMarker2DPosition: null,
    entityDrag2DPosition: null,
    groupIsXInverted: false,
    groupIsYInverted: false,
    copiedEntityIds: [],
    sceneEntityListIsVisible: false,
    sceneEntityListPosition: [0, 0],
    currentSceneIndex: 0,
    scrollSceneMenu: false,
    sceneSnapshots: {},
    sceneCarouselScrollLeft: 0,
    sceneMenuIsLarge: false,
    sceneNameInputIsFocused: false,
    project: { id: '', title: '' },
    projectSizeLimit: null,
    loggedInUsers: {},
    canvasLoaded: false,
    entityMenuDragActive: false,
    entityDragHotspotPosition: null,
    dragState: null,
    loadedImages: null,
    loaded3dModels: null,
    loadedVideos: null,
    loadedBackgroundContent: null,
    loadingMedia: false,
    currentUploads: {},
    numberProcessedUploads: 0,
    trackImgData: null,
    trkImgIsUploading: false,
    pureReactInCanvasHovered: false,
    toasts: [],
    editSceneTitle: false,
    openInspectorMenuEntityShelves: null,
    openInspectorMenuProjectShelves: null,
    openInspectorMenuSceneShelves: null,
    openEntityMenuDrawer: null,
    openEntityCategoryDrawerDict: {},
    selectedAudio: null,
    mediaLibraryDisplay: {
        fileTypes: [],
        onSubmitCategory: IMediaLibraryOnSubmitCategory.AddToScene,
    },
    tempAnimateModelAction: null,
    visibleCanvases: {
        selectedEntityPreview: false,
        camera360RotationPreview: false,
        modelUploadPreview: false,
        webEmbedPreview: false,
        screenRelativePreview: false,
        targetImagePreview: false,
        videoPlayer: false,
    },
    positionById: {},
    scaleById: {},
    rotationById: {},
    fillRgbaById: {},
    fontRgbaById: {},
    emitterAreaScalesById: {},
    borderRgbaById: {},
    activeFaceLandmark: null,
    showFaceLandmarks: false,
    hoveredDropdownFacelandmark: null,
    emitterIsStaticById: {},
    curvatureById: {},
    forceUpdateDragControlsTrigger: 0,
    temporaryDragRotation: [0, 0, 0],
    videoProgressById: {},
    showPublishPopup: false,
    publishTrigger: 0,
    updateTrigger: 0,
    projectSize: null,
    spinnerData: {},
    isProjectDuplicating: false,
    showAppClipsModal: null,
    publishBtnStatus: 'idle',
    previewBtnStatus: 'idle',
    appClipsConverted: null,
    activePreviewTrackingImageIndex: null,
    whatsNewTrigger: 0,
    isUserAuthorized: false,
    launchPageIconFilestoreId: null,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case IUserActionTypes.SET_ACTIVE_EDITING_ACTION_DATA:
            return setActiveEditingActionData(state, action);
        case IUserActionTypes.SET_POPOUT_IDEAL_TOP_POSITION:
            return setPopOutIdealTopPosition(state, action);
        case IUserActionTypes.SET_MULTIPLE_ENTITY_SELECT_BOUNDARY:
            return setMultipleEntitySelectBoundary(state, action);
        case IUserActionTypes.SET_CHROMA_KEY_EDIT_MODAL_DATA:
            return setChromaKeyEditModalData(state, action);
        case IUserActionTypes.SET_SELECTED_TEMPLATE_PROJECT:
            return setSelectedTemplateProject(state, action);
        case IUserActionTypes.SET_TARGET_IMAGE_REFERENCE_OBJECT_POSITION:
            return setTargetImageReferenceObjectPosition(state, action);
        case IUserActionTypes.SET_ACTIVE_ANIMATION_PRESET:
            return setActiveAnimationPreset(state, action);
        case IUserActionTypes.OPEN_MODAL:
            return setOpenModal(state, action);
        case IUserActionTypes.CLOSE_MODAL:
            return setCloseModal(state, action);
        case IUserActionTypes.SET_MEDIA_LIBRARY_DISPLAY:
            return setMediaLibraryDisplay(state, action);
        case IUserActionTypes.SET_OPEN_SCENE_MENU_DRAWER:
            return setOpenSceneMenuDrawer(state, action);
        case IUserActionTypes.SET_TEMP_ANIMATE_MODEL_ACTION:
            return setTempAnimateModelAction(state, action);
        case IUserActionTypes.SET_OPEN_PROJECT_MENU_DRAWER:
            return setOpenProjectMenuDrawer(state, action);
        case IUserActionTypes.SET_WEB_EMBED_PREVIEW_SETTINGS:
            return setWebEmbedPreviewSettings(state, action);
        case IUserActionTypes.SET_WEB_EMBED_EDITING_MODE:
            return setIsWebEmbedEditingMode(state, action);
        case IUserActionTypes.SET_OPEN_ENTITY_MENU_DRAWER:
            return setOpenEntityMenuDrawer(state, action);
        case IUserActionTypes.SET_OPEN_ENTITY_MENU_CATEGORY_DRAWER:
            return setOpenEntityMenuCategoryDrawer(state, action);
        case IUserActionTypes.SET_REPLACE_ENTITY_MODE:
            return setReplaceEntityMode(state, action);
        case IUserActionTypes.SET_FILE_VERIFYING:
            return setFileVerifying(state, action);
        case IUserActionTypes.SET_OPEN_INSPECTOR_MENU_ENTITY_SHELF:
            return setOpenInspectorMenuEntityShelf(state, action);
        case IUserActionTypes.SET_USER_ID:
            return setUserId(state, action);
        case IUserActionTypes.UPDATE_USERS:
            return updateUsers(state, action);
        case IUserActionTypes.SET_TRACKING_IMG_DATA:
            return setTrackingImageData(state, action);
        case IUserActionTypes.REMOVE_TRACKING_IMG_DATA:
            return removeTrackingImageData(state);
        case IUserActionTypes.SET_TRACKING_IMG_UPLOADING:
            return setTrackingImageIsUploading(state, action);
        case IUserActionTypes.CANVAS_IS_LOADED:
            return setCanvasIsLoaded(state, action);
        // case IUserActionTypes.SET_LOADED_AUDIO:
        // 	return setLoadedAudio(state, action);
        case IUserActionTypes.SET_LOADED_360_BACKGROUND:
            return setLoadedBackground360Content(state, action);
        // case IUserActionTypes.ADD_TO_LOADED_MEDIA:
        // 	return addToLoadedMedia(state, action);
        // case IUserActionTypes.ADD_TO_LOADED_AUDIO:
        // 	return addToLoadedAudio(state, action);
        case IUserActionTypes.REMOVE_LOADED_MEDIA:
            return removeLoadedMedia(state, action);
        case IUserActionTypes.LOADING_MEDIA:
            return isLoadingMedia(state, action);
        case IUserActionTypes.REMOVE_UPLOAD:
            return removeUpload(state, action);
        case IUserActionTypes.SET_CURRENT_UPLOADS:
            return setCurrentUploads(state, action);
        case IUserActionTypes.ADD_TOAST:
            return addToast(state, action);
        case IUserActionTypes.REMOVE_TOAST:
            return removeToast(state, action);
        case IUserActionTypes.SET_PROJECT_INFO:
            return setProjectInfo(state, action);
        case IUserActionTypes.SET_HOTKEY:
            return setHotKey(state, action);
        case IUserActionTypes.SET_MARKER_INDEX_PRESSED:
            return setMarkerIndexPressed(state, action);
        case IUserActionTypes.REMOVE_HOTKEY:
            return removeHotKey(state, action);
        case IUserActionTypes.SET_POSITIONING_ACTIVE:
            return setPositioningActive(state, action);
        case IUserActionTypes.SET_ROTATION_ACTIVE:
            return setRotationActive(state, action);
        case IUserActionTypes.SET_SCALE_HOTSPOT_ENABLED:
            return setScaleHotSpotEnabled(state, action);
        case IUserActionTypes.SET_BACKGROUND_HOTSPOT_ENABLED:
            return setBackgroundHotSpotEnabled(state, action);
        case IUserActionTypes.SET_CLICK_OFFSET:
            return setPointerOffset(state, action);
        case IUserActionTypes.ADD_ENTITY_IDS_TO_SELECTION:
            return addEntityIdsToSelection(state, action);
        case IUserActionTypes.REMOVE_SELECTION:
            return removeSelection(state, action);
        case IUserActionTypes.REMOVE_LOCAL_USER_SELECTION:
            return removeLocalUserSelection(state, action);
        case IUserActionTypes.CHANGE_ZOOM_LEVEL:
            return changeZoomLevel(state, action);
        case IUserActionTypes.DISABLE_UNDO_BTN:
            return disableUndo(state, action);
        case IUserActionTypes.DISABLE_REDO_BTN:
            return disableRedo(state, action);
        case IUserActionTypes.SET_GROUP_INVERSION:
            return setGroupInversion(state, action);
        case IUserActionTypes.SET_SELECTION_2D_POSITION:
            return setSelection2DPosition(state, action);
        case IUserActionTypes.SET_SELECTION_2D_TOP_LEFT_POSITION:
            return setSelection2DTopLeftPosition(state, action);
        case IUserActionTypes.SET_SELECTION_2D_TOP_RIGHT_POSITION:
            return setSelection2DTopRightPosition(state, action);
        case IUserActionTypes.SET_SELECTION_2D_BOTTOM_LEFT_POSITION:
            return setSelection2DBottomLeftPosition(state, action);
        case IUserActionTypes.SET_SELECTION_2D_BOTTOM_RIGHT_POSITION:
            return setSelection2DBottomRightPosition(state, action);
        case IUserActionTypes.SET_ROTATION_MARKER_2D_POSITION:
            return setRotationMarker2DPosition(state, action);
        case IUserActionTypes.SET_ENTITY_MENU_DRAG_ACTIVE:
            return setEntityMenuDragActive(state, action);
        case IUserActionTypes.SET_ENTITY_MENU_DRAG_HOTSPOT_POSITION:
            return setEntityMenuHotspotDragPosition(state, action);
        case IUserActionTypes.SET_PURE_REACT_IN_CANVAS_HOVERED:
            return setPureReactInCanvasHovered(state, action);
        case IUserActionTypes.SET_ENTITY_MENU_DRAG_INFO:
            return setEntityDragInfo(state, action);
        // case IUserActionTypes.SET_AUDIO_STATUS:
        // 	return setAudioStatus(state, action);
        case IUserActionTypes.COPY_SELECTED_ENTITIES:
            return copySelectedEntities(state, action);
        case IUserActionTypes.SET_ACTIVE_SCENE:
            return setActiveScene(state, action);
        case IUserActionTypes.SET_CURRENT_SCENE_INDEX:
            return setCurrentSceneIndex(state, action);
        case IUserActionTypes.SCROLL_SCENE_MENU:
            return scrollSceneMenu(state, action);
        case IUserActionTypes.SET_SCENE_SNAPSHOTS:
            return setSortedSceneSnapshots(state, action);
        case IUserActionTypes.SET_SCENE_ENTITY_LIST_VISIBLE:
            return setSceneEntityListVisible(state, action);
        case IUserActionTypes.SET_SCENE_CAROUSEL_SCROLL_LEFT:
            return setSceneCarouselScrollLeft(state, action);
        case IUserActionTypes.SET_SCENE_MENU_LARGE:
            return setSceneMenuLarge(state, action);
        case IUserActionTypes.FOCUS_SCENE_NAME_INPUT:
            return focusSceneNameInput(state, action);
        case IUserActionTypes.SET_SOCKET_CONNECTED:
            return setSocketConnected(state, action);
        case IUserActionTypes.SET_PROJECT_LOADING_PROGRESS:
            return setProjectLoadingProgress(state, action);
        case IUserActionTypes.SET_PROJECT_LOADING_FAILURE:
            return setProjectLoadingFailure(state, action);
        case IUserActionTypes.EDIT_SCENE_TITLE:
            return setEditSceneTitle(state, action);
        case IUserActionTypes.SET_SELECTED_ENTIY_IDS:
            return setSelectedEntityIds(state, action);
        case IUserActionTypes.SET_3D_MODE:
            return set3dMode(state, action);
        case IUserActionTypes.SET_SCREEN_RELATIVE_MODE:
            return setIsScreenRelativeMode(state, action);
        case IUserActionTypes.SET_TRANSFORM_CONTROLS_ACTIVE:
            return setTransformControlsActive(state, action);
        case IUserActionTypes.SET_TRANSFORM_CONTROLS_MODE:
            return setTransformControlsMode(state, action);
        case IUserActionTypes.SET_SCREEN_RELATIVE_DEVICE:
            return setScreenRelativeDevice(state, action);
        case IUserActionTypes.SET_SCREEN_RELATIVE_DEVICE_PREVIOUS_CUSTOM_DIMENSIONS:
            return setScreenRelativeDevicePreviousCustomDimensions(state, action);
        case IUserActionTypes.SET_SELECTED_AUDIO:
            return setSelectedAudio(state, action);
        case IUserActionTypes.SET_VISIBLE_CANVAS:
            return setVisibleCanvas(state, action);
        case IUserActionTypes.SET_FILL_RGBA:
            return setFillRgba(state, action);
        case IUserActionTypes.SET_FONT_RGBA:
            return setFontRgba(state, action);
        case IUserActionTypes.SET_BORDER_RGBA:
            return setBorderRgba(state, action);
        case IUserActionTypes.SET_POSITIONS:
            return setPositions(state, action);
        case IUserActionTypes.SET_CURVATURES:
            return setCurvatures(state, action);
        case IUserActionTypes.SET_SCALES:
            return setScales(state, action);
        case IUserActionTypes.SET_EMITTER_AREA_SCALES:
            return setEmitterAreaScales(state, action);
        case IUserActionTypes.SET_ROTATIONS:
            return setRotations(state, action);
        case IUserActionTypes.SET_ACTIVE_FACE_LANDMARK:
            return setActiveFaceLandmark(state, action);
        case IUserActionTypes.SET_SHOW_FACE_LANDMARKS:
            return setShowFaceLandmarks(state, action);
        case IUserActionTypes.SET_HOVERED_FACE_LANDMARK_DROPDOWN:
            return setHoveredDropdownFaceLandmark(state, action);
        case IUserActionTypes.SET_PROJECT_SIZE_LIMIT:
            return setProjectSizeLimit(state, action);
        case IUserActionTypes.SET_PROJECT_SIZE:
            return setProjectSize(state, action);
        case IUserActionTypes.SET_EMITTER_IS_STATIC:
            return setEmitterIsStatic(state, action);
        case IUserActionTypes.SET_PREVIEW_CODE_SRC:
            return setPreviewCodeSrc(state, action);
        case IUserActionTypes.SET_PREVIEW_URL:
            return onSetPreviewUrl(state, action);
        case IUserActionTypes.SET_DRAG_CONTROLS_UPDATE_TRIGGER:
            return setDragControlsUpdateTrigger(state, action);
        case IUserActionTypes.SET_TEMP_INITIAL_ROTATION:
            return setTemporaryDragRotation(state, action);
        case IUserActionTypes.SET_VIDEO_RENDITION_PROGRESS:
            return setVideoRenditionProgress(state, action);
        case IUserActionTypes.SET_SHOW_PUBLISH_POPUP:
            return setPublishPopup(state, action);
        case IUserActionTypes.SET_PUBLISH_TRIGGER:
            return setPublishTrigger(state, action);
        case IUserActionTypes.SET_ACTIVE_PREVIEW_TRACKING_IMAGE_INDEX:
            return setActivePreviewTrackingImageIndex(state, action);
        case IUserActionTypes.SET_UPDATE_TRIGGER:
            return setUpdateTrigger(state, action);
        case IUserActionTypes.SET_WHATS_NEW_TRIGGER:
            return setWhatsNewTrigger(state);
        case IUserActionTypes.SET_SPINNER_COORDINATES:
            return setSpinnerCoordinates(state, action);
        case IUserActionTypes.SET_PROJECT_DUPLICATING:
            return setProjectDuplicatingState(state, action);
        case IUserActionTypes.SET_SHOW_APP_CLIPS_MODAL:
            return setShowAppClipsModal(state, action);
        case IUserActionTypes.SET_PUBLISH_BTN_STATUS:
            return setPublishBtnStatus(state, action);
        case IUserActionTypes.SET_PREVIEW_BTN_STATUS:
            return setPreviewBtnStatus(state, action);
        case IUserActionTypes.SET_APP_CLIPS_CONVERTED:
            return setAppClipsConverted(state, action);
        case IUserActionTypes.SET_IS_USER_AUTHORIZED:
            return setIsUserAuthorized(state, action);
        case IUserActionTypes.SET_LAUNCH_PAGE_ICON_FILESTORE_ID:
            return setLaunchPageIconFilestoreId(state, action);
        default:
            return state;
    }
};
export default userReducer;
